import React, { ReactNode } from 'react';
import { Box, Typography, Paper, Table, TableProps, TableCell, TableCellProps, TableRow, TableRowProps, Button, ButtonProps, SxProps, Tooltip } from '@mui/material';
import { useThemeContext } from '../../theme/ThemeContext';

export const ISTableTitle = ({ title, children, sx }: { title?: string, children?: ReactNode, sx?: SxProps }) => {
  const { theme } = useThemeContext()

  return (<Box sx={{ ...sx, borderRadius: "10px 10px 0 0", bgcolor: theme.palette.success.main }}>
    {title && <Typography variant="h6" sx={{ padding: "10px", color: theme.palette.success.dark }}>{title}</Typography>}
    {children}
  </Box>)
}

export const ISTableTitleSubtitle = ({ title, subtitle, children, sx }: { title?: string, subtitle?: string, children?: ReactNode, sx?: SxProps }) => {
  const { theme } = useThemeContext()

  return (<Box sx={{ ...sx, borderRadius: "10px 10px 0 0", bgcolor: theme.palette.success.main }}>
    {title && subtitle && <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography variant="h6" sx={{ padding: "10px", color: theme.palette.success.dark }}>{title}</Typography>
      <Typography variant="subtitle1" sx={{ color: theme.palette.success.dark }}>{subtitle}</Typography>
      </div>}
    {children}
  </Box>)
}

interface Props {
  children?: React.ReactNode
  color: 'default' | 'green' | 'yellow' | 'red';
}

export const ISTableRow: React.FC<Props & TableRowProps> = (props) => {
  return (
    <TableRow hover={true} sx={{ ...props.sx, fontSize: '26px' }} {...props}>
      {props.children}
    </TableRow>
  );
}

interface ISTableButtonProps extends ButtonProps {
  text?: string
  children?: React.ReactNode
  status?: boolean
}

export const ISTableButton: React.FC<ISTableButtonProps> = (props) => {
  const { theme, darkModeEnabled } = useThemeContext()

  return (<Button size="small"
    {...props}
    sx={{
      maxHeight: '25px', borderRadius: "15px", 
      color: theme.typography.button, textTransform: 'none', 
      backgroundColor: props.status ? darkModeEnabled ? theme.palette.action.disabled : theme.palette.action.hover : theme.palette.action.selected,
      "&.Mui-selected": {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.info.main // action.active
      },
      ":hover": {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.main
      }
    }}
  >
    <Box display='flex' alignItems='center' padding="10px">
      <Typography color='inherit' variant="caption">{props.text}</Typography>
      {props.children}
    </Box>
  </Button>)
}


interface ISTableCellProps extends TableCellProps {
  tooltip?: React.ReactNode
  placement?: any
}

export const ISTableCell: React.FC<ISTableCellProps> = (props) => {
  const { theme } = useThemeContext()
  const cell: React.ReactNode = <TableCell {...props}> {props.children} </TableCell>

  return (props.tooltip ? <Tooltip
    placement={props.placement ? props.placement : 'bottom'}
    componentsProps={{
      tooltip: {
        sx: {
          //bgcolor: "transparent",
          bgcolor: theme.palette.background.paper, //default,
          padding: "0px",
          border: '1px solid',
        }
      }
    }}
    title={props.tooltip} >{cell}</Tooltip> : cell)

}

export const ISTableHeaderCell: React.FC<ISTableCellProps> = (props) => {
  const { theme } = useThemeContext()
  const cell: React.ReactNode = <TableCell {...props} style={{ ...props.style, fontWeight: 'bold' }}>{props.children}</TableCell>

  return (props.tooltip ? <Tooltip
    placement={props.placement ? props.placement : 'bottom'}
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: theme.palette.background.paper, //default,
          padding: "0px",
          border: '1px solid'
        }
      }
    }}
    title={props.tooltip} >{cell}</Tooltip> : cell)

}

const ISTable: React.FC<TableProps> = (props) => {
  return (
    <Paper square>
      <Table size="medium" {...props}>
        {props.children}
      </Table>
    </Paper>

  )
}
export default ISTable

